import * as React from 'react'
import PdfHandler from '@/components/pdfHandler/PdfHandler'
import { View, Text, StyleSheet, Svg, Line } from '@react-pdf/renderer'
import { IScene } from '@/store/apis/scenes'
import { useTranslation } from 'react-i18next'

const styles = StyleSheet.create({
  title: {
    fontSize: 24,
    textAlign: 'center',
    marginBottom: 20,
  },
  scene: {
    marginBottom: 20,
  },
  userWrapper: {
    marginBottom: 20,
  },
  users: {
    marginTop: 12,
    marginLeft: 25,
    fontSize: 12,
    textAlign: 'justify',
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey',
  },
})

interface IPdfHandlerProps {
  schemaName: string
  schemaUserCount: number
  scenes: IScene[]
}

const PdfScenes: React.FC<IPdfHandlerProps> = ({
  schemaName,
  schemaUserCount,
  scenes,
}) => {
  const { t } = useTranslation()
  return (
    <PdfHandler title={`${t('scenesPdf.title')} - ${schemaName}`}>
      <Text
        style={styles.title}
      >{`${t('scenesPdf.title')} - ${schemaName}`}</Text>
      {scenes.map((scene, index) => (
        <View key={index} style={styles.scene}>
          <Text>{scene.scene.name}</Text>
          <View style={styles.userWrapper}>
            <Text style={styles.users}>
              {scene.users.length < schemaUserCount
                ? scene.users
                    .map((user) => `${user.firstName} ${user.lastName}`)
                    .join(', ')
                : t('pdf.all').toUpperCase()}
            </Text>
          </View>
          <Svg height="10" width="1000">
            <Line
              x1="0"
              y1="5"
              x2="280"
              y2="5"
              strokeWidth={1}
              stroke="rgb(0,0,0)"
            />
          </Svg>
        </View>
      ))}
      <Text
        style={styles.pageNumber}
        render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
        fixed
      />
    </PdfHandler>
  )
}

export default PdfScenes
